<template>
  <div>
    {{ showClosePopUp }} {{ getConfirmBoxResponse }}
    <!-- {{getFileList}} -->
    <div v-if="showlist">
      <transition name="modal">
        <div
          class="modal-mask upl-holdNEW wdth-700"
          style="overflow-y: auto; display: block"
        >
          <div class="modal-wrapper">
            <div class="modal-container">
              <!--Modal header-->
              <div class="modal-header">
                <slot name="header" style="border: 1px red">
                  <!-- <h5 class="modal-title">File List</h5> -->
                  <h4 class="modal-title mt-2">{{ $t('ViewPackages') }}</h4>
                  <button
                    type="button"
                    aria-label="Close"
                    class="close up-close"
                    @click.prevent="closePopUp('goBack')"
                  >
                    ×
                  </button>
                </slot>
              </div>
              <!--Modal Body-->

              <div class="modal-body">
                <div class="view-packages-body">
                  <!-- <h2>View packages</h2> -->
                  <div class="view-packages-button">
                    <button
                      type="button"
                      class="secondary-btn ripple"
                      data-toggle="modal"
                      data-target="#expired"
                      @click="showExpiredPackages()"
                    >
                      {{ $t('Expired') }}
                    </button>
                    <button
                      type="button"
                      class="primary-btn ripple"
                      data-toggle="modal"
                      data-target="#live"
                      @click="showLivePackages()"
                    >
                      {{$t('Live')}}
                    </button>
                  </div>
                </div>
                <div
                  class="modal fade packages-popup packages-inner-popup"
                  id="expired"
                  tabindex="-1"
                  role="dialog"
                  aria-labelledby="exampleModalCenterTitle"
                  aria-hidden="true"
                >
                  <div class="modal-dialog" role="document">
                    <div class="modal-content">
                      <div class="modal-header">
                        <button
                          type="button"
                          class="close"
                          @click="closeselectedpack"
                          data-dismiss="modal"
                          aria-label="Close"
                        >
                          <span aria-hidden="true">&times;</span>
                        </button>
                      </div>
                      <div class="modal-body">
                        <div class="packages-table">
                          <h2>Expired packages</h2>
                          <div class="table-responsive">
                            <div v-if="inactive_packages.length > 0">
                              <table class="table">
                                <thead>
                                  <tr>
                                    <th>Membership Number</th>
                                    <th>Package Name</th>
                                    <th>Amount</th>
                                    <th>Currency</th>
                                    <th>Expired Date</th>
                                    <th>View</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr
                                    v-for="(item, index) in inactive_packages"
                                  >
                                    <td>{{ item.Membership_number }}</td>
                                    <td>{{ item.Package_id }}</td>
                                    <td>
                                      {{
                                        twoDecimal(item.Package_purchase_value)
                                      }}
                                    </td>
                                    <td>{{ item.Currency }}</td>
                                    <td>
                                      {{new Date(item.Membership_number_expiry).toLocaleString("en-GB", {
                                      hour12: true,
                                      dateStyle: "short",
                                      timeStyle: "short",
                                      })
                                        
                                      }}
                                    </td>
                                    <td>
                                      <a
                                        href="javascript:void(0);"
                                        data-original-title="View"
                                        class="action-view"
                                        @click="getinactivepackservice(item)"
                                      ></a>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                            <div class="no-content-added" v-else>
                              <span class="col-md-12 text-center pt-4 d-block"
                                >No expired packages found.</span
                              >
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div v-if="showloader">
                    <div
                      class="processing_popup upload full-spinner"
                      style="visibility: visible"
                    >
                      <div class="spinner">
                        <div class="bounce1"></div>
                        <div class="bounce2"></div>
                        <div class="bounce3"></div>
                      </div>
                    </div>
                  </div>
                  </div>
                </div>
                <div
                  class="modal fade packages-popup packages-inner-popup"
                  id="live"
                  tabindex="-1"
                  role="dialog"
                  aria-labelledby="exampleModalCenterTitle"
                  aria-hidden="true"
                >
                  <div class="modal-dialog" role="document">
                    <div class="modal-content">
                      <div class="modal-header">
                        <button
                          type="button"
                          @click="closeselectedpack"
                          class="close"
                          data-dismiss="modal"
                          aria-label="Close"
                        >
                          <span aria-hidden="true">&times;</span>
                        </button>
                      </div>
                      <div class="modal-body">
                        <div class="packages-table">
                          <h2>Live packages</h2>
                          <div class="table-responsive">
                            <div v-if="active_packages.length > 0">
                              <table class="table">
                                <thead>
                                  <tr>
                                    <th>Membership Number</th>
                                    <th>Package Name</th>
                                    <th>Purchase Date</th>
                                    <th>Amount</th>
                                    <th>Currency</th>
                                    <th>Select</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr v-for="(item, index) in active_packages">
                                    <td>{{ item.Membership_number }}</td>
                                    <td>{{ item.Package_id }}</td>
                                    <td>
                                      {{new Date(item.Package_creation_date).toLocaleString("en-GB", {
                                      hour12: true,
                                      dateStyle: "short",
                                      timeStyle: "short",
                                      })
                                        
                                      }}
                                    </td>
                                    <td>
                                      {{
                                        twoDecimal(item.Package_purchase_value)
                                      }}
                                    </td>
                                    <td>{{ item.Currency }}</td>
                                    <td>
                                      <input
                                        type="radio"
                                        v-model="selectedpack"
                                        :value="item"
                                      />
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                            <div class="no-content-added" v-else>
                              <span class="col-md-12 text-center pt-4 d-block"
                                >No services found.</span
                              >
                            </div>
                            <button
                              type="button"
                              class="primary-btn ripple pull-right"
                              v-if="selectedpack"
                              @click="viewactiveservices"
                            >
                              View
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div v-if="showloader">
                    <div
                      class="processing_popup upload full-spinner"
                      style="visibility: visible"
                    >
                      <div class="spinner">
                        <div class="bounce1"></div>
                        <div class="bounce2"></div>
                        <div class="bounce3"></div>
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  class="modal fade packages-popup packages-inner-popup"
                  id="activeservices"
                  tabindex="-1"
                  role="dialog"
                  aria-labelledby="exampleModalCenterTitle"
                  aria-hidden="true"
                >
                  <div class="modal-dialog" role="document">
                    <div class="modal-content">
                      <div class="modal-header">
                        <button
                          type="button"
                          class="close"
                          @click="closeactiveservicepopup"
                          data-dismiss="modal"
                          aria-label="Close"
                        >
                          <span aria-hidden="true">&times;</span>
                        </button>
                      </div>
                      <div class="modal-body">
                        <div class="packages-table" v-if="selectedpack">
                          <h2>Package Name: {{ selectedpack.Package_id }}</h2>

                          <div class="table-responsive">
                            <div v-if="activeList.length > 0">
                              <table class="table">
                                <thead>
                                  <tr>
                                    <th>Service</th>
                                    <th>Cost</th>
                                    <th>Currency</th>
                                    <th>Redeemed Date</th>
                                    <th>Note</th>
                                    <th>Select</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr v-for="(item, index) in activeList">
                                    <td>{{ item.Service_Name }}</td>
                                    <td>
                                      {{ twoDecimal(item.Component_balance) }}
                                    </td>
                                    <td>{{ item.Currency }}</td>
                                    <td>
                                      {{
                                        item.Active
                                          ? new Date(item.Component_used_date_time).toLocaleString("en-GB", {
                                      hour12: true,
                                      dateStyle: "short",
                                      timeStyle: "short",
                                      })
                                          : ""
                                      }}
                                    </td>
                                    <td
                                      v-bind:class="{
                                        'global-disabled':
                                          item.Is_used == 'True',
                                      }"
                                    >
                                      <input type="text" v-model="item.Notes" />
                                    </td>
                                    <td
                                      v-bind:class="{
                                        'global-disabled':
                                          item.Is_used == 'True',
                                      }"
                                    >
                                      <input
                                        type="checkbox"
                                        :value="item"
                                        v-model="selectedservice"
                                        :checked="item.Active"
                                      />
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                            <div class="no-content-added" v-else>
                              <span class="col-md-12 text-center pt-4 d-block"
                                >No services found.</span
                              >
                            </div>
                            <button
                              type="button"
                              class="primary-btn ripple pull-right"
                              v-if="markingservice.length > 0"
                              @click="redeemservices"
                            >
                              Redeem
                            </button>
                          </div>
                        </div>
                         <div v-if="showloader">
                    <div
                      class="processing_popup upload full-spinner"
                      style="visibility: visible"
                    >
                      <div class="spinner">
                        <div class="bounce1"></div>
                        <div class="bounce2"></div>
                        <div class="bounce3"></div>
                      </div>
                    </div>
                  </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  class="modal fade packages-popup packages-inner-popup"
                  id="inactiveservices"
                  tabindex="-1"
                  role="dialog"
                  aria-labelledby="exampleModalCenterTitle"
                  aria-hidden="true"
                >
                  <div class="modal-dialog" role="document">
                    <div class="modal-content">
                      <div class="modal-header">
                        <button
                          type="button"
                          class="close"
                          data-dismiss="modal"
                          aria-label="Close"
                        >
                          <span aria-hidden="true">&times;</span>
                        </button>
                      </div>
                      <div class="modal-body">
                        <div class="packages-table">
                          <h2 v-if="selectedpack != null">
                            Package Name: {{ selectedpack.Package_id }}
                          </h2>
                          <div class="table-responsive">
                            <table class="table" v-if="inactive_services">
                              <thead>
                                <tr>
                                  <th>Service</th>
                                  <th>Cost</th>
                                  <th>Currency</th>
                                  <th>Redeemed Date</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr v-for="(item, index) in inactive_services">
                                  <td>{{ item.Service_Name }}</td>
                                  <td>
                                    {{ twoDecimal(item.Component_balance) }}
                                  </td>
                                  <td>{{ item.Currency }}</td>
                                  <td>
                                    {{
                                      item.Active
                                        ?  new Date(item.Component_used_date_time).toLocaleString("en-GB", {
                                      hour12: true,
                                      dateStyle: "short",
                                      timeStyle: "short",
                                      })
                                        : ""
                                    }}
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- <div class="modal-body" v-if="!(filelist && filelist.length)" style="text-align:center;">
                No files have been added so far.
              </div>-->
            </div>
          </div>
        </div>
      </transition>
    </div>
    <!-- <reportUploadPopUp ref="reportUploadPopupRef" :showmodal=showModal :parentObj=parentobj :encounterid=recentappointment.encounter_id :investigationid=selectedInvestigationId :selectedReportType=selectedReportType :selectedTestType=selectedTestType>
    <reportUploadPopUp ref="reportUploadPopupRef" :showmodal=showModal :parentObj=parentobj :encounterid=invObj.encounter_id :investigationid=invObj.unique_id :selectedReportType=invObj.category_name :selectedTestType=invObj.investigation_name :tenantid =invObj.tenant_id :filescanbeuploaded=parseInt(invObj.filescanbeuploaded,10) :webreportcanbeuploaded=parseInt(invObj.webreportcanbeuploaded,10) :maxreportfilecount=parseInt(invObj.maxreportfilecount,10) :maxwebreportcount=parseInt(invObj.maxwebreportcount,10)>
    </reportUploadPopUp>

    <reportUploadPopUp v-if="editableObj.editable_unique_id" ref="reportUpdatePopupRef" :updatemodal=showUpdateModal :parentObj=parentobj :encounterid=editableObj.editable_encounter_id :investigationid=editableObj.editable_unique_id :selectedReportType=editableObj.editable_category_name :selectedTestType=editableObj.editable_investigation_name :diagnosticcentername=editableObj.editable_diagnostic_center_name :uploadednotes=editableObj.editable_report_notes :reportweburl=editableObj.editable_report_webUrl :reportweburluname=editableObj.editable_report_webUrlUname :reportweburlpass=editableObj.editable_report_webUrlPass :tenantid=editableObj.editable_tenant_id :webreportid=editableObj.webReportId>
    </reportUploadPopUp>-->

    <transition name="fade">
      <Messages
        v-if="isdisplaymsg"
        :datamessage="sucessmsgtext"
        v-on:closemsg="closeMessage"
        v-bind:isVisible="isdisplaymsg"
      ></Messages>
    </transition>
    <!-- Confirm POP UP START-->
    <ConfirmBox
      ref="confirmcomp"
      :showmodal="showCnfrmPopUp"
      :actionmessage="actionMsg"
      @cancelAction="
        showCnfrmPopUp = false;
        confrmPopUpResponse = false;
      "
      @confirmAction="
        showCnfrmPopUp = false;
        confrmPopUpResponse = true;
      "
    >
      <!--
            you can use custom content here to overwrite
            default content
            <h3 slot="header">{{customheadertxt}}</h3>
      -->
    </ConfirmBox>
    <!-- Confirm POP UP END-->
  </div>
</template>

<script>
// import reportUploadPopUp from "@/components/TestReportComponent/TestReportPopup.vue";
import rest_service from "@/api/rest_service";
import Axios from "axios";
import { mapActions, mapGetters, Store } from "vuex";
import Messages from "@/components/MessagePopup/Messages";
import ConfirmBox from "@/components/MessagePopup/ConfirmPopup";
import moment from "moment";
import Auth from "@/common/mixins";

var getinvestigationbyencounterurl =
  "/investigation/getinvestigationbyencounteranduniqueid";
var patient_report_delete_url = "/investigation/deleteTestReportByPatient";
var getencounterstatusurl = "/formrender/checkencounterstatus";

export default {
  mixins: [Auth],
  props: ["showlist", "parentObj", "filelist", "patientmobno"],
  components: {
    //   reportUploadPopUp,
    Messages,
    ConfirmBox,
  },
  data() {
    return {
      showloader: false,
      markingservice: [],
      recordtoupdate: null,
      selectedservice: [],
      active_services: [],
      inactive_services: [],
      activeList: [],
      selectedpack: null,
      show_modal: false,
      parentproperty: this.parentObj,
      invObj: [],
      showModal: false,
      parentobj: this,
      selectedTestType: "",
      selectedReportType: "",
      selectedInvestigationId: "",
      encounterIdL: "",
      showUpdateModal: false,
      loggedincustomerdetails: {},
      tenant_id: "",
      loggedin_user_unique_id: "",
      role_unique_id: "",
      authenticationToken: "",
      getFileListFromParent: false,
      isdisplaymsg: false,
      sucessmsgtext: "",
      getdownloadfileUrl: "",
      showCnfrmPopUp: false,
      confrmPopUpResponse: false,
      actionMsg: "Are you sure want to",
      customheadertxt: "Confirm Action",
      showauthenticationcheck: false,
      recordToDelete: null,
      recordType: "",
      isProvider: true,
      reportListIndex: 0,
      needMultipleBtn: false,
      editableObj: {
        editable_encounter_id: "",
        editable_unique_id: "",
        editable_category_name: "",
        editable_investigation_name: "",
        editable_diagnostic_center_name: "",
        editable_report_notes: "",
        editable_report_webUrl: "",
        editable_report_webUrlUname: "",
        editable_report_webUrlPass: "",
        editable_tenant_id: "",
        webReportId: "",
      },
      isEncounterActive: false,
      active_packages: [],
      inactive_packages: [],
      truncatelength: parseInt(process.env.VUE_APP_TEXT_TRUNCATE_LENGTH, 10),
    };
  },
  created() {
    if (Auth.checkAuthentication()) {
      this.tenant_id = localStorage.tenantid;
      this.authenticationToken = localStorage.accesstoken;
      if (localStorage.loggedInUserInfo) {
        let loggedinuser = JSON.parse(localStorage.loggedInUserInfo);
        this.loggedin_user_unique_id = loggedinuser.unique_id;
        this.role_unique_id = loggedinuser.role.unique_id;
      }
      // this.checkencounterstatus();
    }
  },
  mounted() {},
  methods: {
    closeselectedpack() {
      this.selectedpack = null;
    },
    twoDecimal(number) {
      return Number(number).toLocaleString("en-IN", {
        maximumFractionDigits: 2,
        minimumFractionDigits: 2,
      });
    },
    adjustDateTime(time) {
      debugger;
      const momentObj = moment.utc(time, "MM-DD-YYYY HH:mm:ss");
      const localDateTime = momentObj.local();
      var datetime = localDateTime.format("DD-MM-YYYY HH:mm:ss A");
      return datetime;
    },
    getinactivepackservice(item) {
      var authenticationToken = "";
      var role_unique_id = "";
      var loggeedin_userinfo = "";
      var loggedin_user_unique_id = "";
      debugger;

      var patientmob = this.patientmobno;
      var provider = JSON.parse(localStorage.getItem("loggedInUserInfo"));
      var api_url = rest_service.baseURL + "/Package/GetpackageServices";
      // var api_url = "http://localhost:49517/api/V1/Package/GetpackageServices";
      if (window.localStorage.getItem("accesstoken")) {
        authenticationToken = window.localStorage.getItem("accesstoken");
      }
      var tenantId = provider.tenant_id; // self.$store.state.helper.tenant_id;

      if (provider) {
        if (provider.role) {
          role_unique_id = provider.role.unique_id;
          loggedin_user_unique_id = provider.unique_id;
        }
      }
      return Axios.request({
        method: "get",
        url: api_url,
        headers: {
          x_tenant_id: tenantId,
          role_unique_id: role_unique_id,
          route_entity_name: "/Package",
          loggedin_user_unique_id: loggedin_user_unique_id,
          Authorization: authenticationToken,
          //"Accept-Encoding": "gzip"
        },
        params: {
          phone: patientmob,
          uniqueid: item.Unique_id,
        },
      })
        .then((response) => {
          debugger;
          if (response.data.result.length > 0) {
            //this.uploadedannfiles = response.data.result;

            var result = response.data.result;
            var result_temp = [];
            this.selectedpack = item;
            this.inactive_services = result;
            this.inactive_services = this.inactive_services
              .slice()
              .sort(
                (a, b) => new Date(b.Updated_date) - new Date(a.Updated_date)
              );
            this.inactive_services.forEach((element) => {
              // item = item + 1;

              debugger;
              if (element.Is_used == "True") {
                element.Active = true;
                // this.selectedservice.push(element);
              } else {
                element.Active = false;
              }
            });
            // this.activeList=this.active_services;

            //  this.active_services = this.activeList;
            $("#inactiveservices").modal("show");
          }
        })
        .catch(function (error) {
          return error;
        });
    },
    closeactiveservicepopup() {
      $("#activeservices").modal("hide");
      this.active_services = [];
      this.activeList = [];
      this.markingservice = [];
      this.selectedservice = [];
    },
    closeMessage() {
      this.isdisplaymsg = false;
    },

    checkservices() {
      this.showloader = true;
      var authenticationToken = "";
      var role_unique_id = "";
      var loggeedin_userinfo = "";
      var loggedin_user_unique_id = "";
      debugger;
      var provider = JSON.parse(localStorage.getItem("loggedInUserInfo"));
      var api_url = rest_service.baseURL + "/Package/Markserviceused";

      //var api_url = "http://localhost:49517/api/V1/Package/Markserviceused";
      if (window.localStorage.getItem("accesstoken")) {
        authenticationToken = window.localStorage.getItem("accesstoken");
      }
      var tenantId = provider.tenant_id; // self.$store.state.helper.tenant_id;

      if (provider) {
        if (provider.role) {
          role_unique_id = provider.role.unique_id;
          loggedin_user_unique_id = provider.unique_id;
        }
      }
      return Axios.request({
        method: "put",
        url: api_url,
        headers: {
          x_tenant_id: tenantId,
          role_unique_id: role_unique_id,
          route_entity_name: "/Package",
          loggedin_user_unique_id: loggedin_user_unique_id,
          Authorization: authenticationToken,
          //"Accept-Encoding": "gzip"
        },
        data: this.recordtoupdate,
      })
        .then((response) => {
          this.showloader = false;
          this.isdisplaymsg = true;
          this.sucessmsgtext = "Services redeemed succesfully";
          setTimeout(
            function () {
              this.closeMessage();
            }.bind(this),
            5000
          );
          this.closeactiveservicepopup();
        })
        .catch(function (error) {
          this.showloader = false;
          return error;
        });
    },
    redeemservices() {
      if (this.selectedservice.length > 0) {
        var services = "";
        var servicesname = "";
        var obj = {
          id: "",
          Notes: [],
          time_zone:"",
        };
        if (this.markingservice.length > 0) {
          this.markingservice.forEach((element) => {
            if (services != "") {
              services = services + ",";
            }
            services = services + element.Unique_id;
            var note = {
              id: element.Unique_id,
              Notes: element.Notes,
            };
            obj.Notes.push(note);

            if (servicesname != "") {
              servicesname = servicesname + ",";
            }
            servicesname = servicesname + element.Service_Name;
          });
          obj.id = services;
          obj.time_zone = Intl.DateTimeFormat().resolvedOptions().timeZone;
          this.recordtoupdate = obj;
          // console.log("Before status change -> Service->", item);
          this.confrmPopUpResponse = false;
          this.actionMsg =
            "Are you sure you want to redeem " + servicesname + " ?";

          this.showCnfrmPopUp = true;
        }
      }
    },
    viewactiveservices() {
      if (this.selectedpack != null) {
        // this.active_services = JSON.parse(this.selectedpack.Services);
        // this.active_services = [];
        var authenticationToken = "";
        var role_unique_id = "";
        var loggeedin_userinfo = "";
        var loggedin_user_unique_id = "";
        debugger;

        var patientmob = this.patientmobno;
        var provider = JSON.parse(localStorage.getItem("loggedInUserInfo"));
        var api_url = rest_service.baseURL + "/Package/GetpackageServices";
        //  var api_url =
        //    "http://localhost:49517/api/V1/Package/GetpackageServices";
        if (window.localStorage.getItem("accesstoken")) {
          authenticationToken = window.localStorage.getItem("accesstoken");
        }
        var tenantId = provider.tenant_id; // self.$store.state.helper.tenant_id;

        if (provider) {
          if (provider.role) {
            role_unique_id = provider.role.unique_id;
            loggedin_user_unique_id = provider.unique_id;
          }
        }
        return Axios.request({
          method: "get",
          url: api_url,
          headers: {
            x_tenant_id: tenantId,
            role_unique_id: role_unique_id,
            route_entity_name: "/Package",
            loggedin_user_unique_id: loggedin_user_unique_id,
            Authorization: authenticationToken,
            //"Accept-Encoding": "gzip"
          },
          params: {
            phone: patientmob,
            uniqueid: this.selectedpack.Unique_id,
          },
        })
          .then((response) => {
            debugger;
            if (response.data.result.length > 0) {
              //this.uploadedannfiles = response.data.result;
              var result = response.data.result;
              var result_temp = [];
              this.active_services = result;
              this.active_services.forEach((element) => {
                // item = item + 1;

                debugger;
                if (element.Is_used == "True") {
                  element.Active = true;
                  this.selectedservice.push(element);
                } else {
                  element.Active = false;
                }
              });
              this.activeList = this.active_services;

              //  this.active_services = this.activeList;
              $("#activeservices").modal("show");
            }
          })
          .catch(function (error) {
            return error;
          });
      }
    },
    showExpiredPackages() {
      this.inactive_packages = [];
      var authenticationToken = "";
      var role_unique_id = "";
      var loggeedin_userinfo = "";
      var loggedin_user_unique_id = "";
      debugger;
      this.showloader = true;

      var patientmob = this.patientmobno;
      var provider = JSON.parse(localStorage.getItem("loggedInUserInfo"));
      var api_url =
        rest_service.baseURL + "/Package/getPatientInActivePackages";
      // var api_url =
      // "http://localhost:49517/api/V1/Package/getPatientInActivePackages";
      if (window.localStorage.getItem("accesstoken")) {
        authenticationToken = window.localStorage.getItem("accesstoken");
      }
      var tenantId = provider.tenant_id; // self.$store.state.helper.tenant_id;

      if (provider) {
        if (provider.role) {
          role_unique_id = provider.role.unique_id;
          loggedin_user_unique_id = provider.unique_id;
        }
      }
      return Axios.request({
        method: "get",
        url: api_url,
        headers: {
          x_tenant_id: tenantId,
          role_unique_id: role_unique_id,
          route_entity_name: "/Package",
          loggedin_user_unique_id: loggedin_user_unique_id,
          Authorization: authenticationToken,
          //"Accept-Encoding": "gzip"
        },
        params: {
          phone: patientmob,
        },
      })
        .then((response) => {
          debugger;
          if (response.data.result.length > 0) {
            //this.uploadedannfiles = response.data.result;
            var result = response.data.result;
            var result_temp = [];
            this.inactive_packages = result;
            this.showloader = false;
          }
          else{
            this.showloader = false;
          }
        })
        .catch(function (error) {
          this.showloader = false;
          return error;

        });
    },
    showLivePackages() {
      this.active_packages = [];
      var authenticationToken = "";
      var role_unique_id = "";
      var loggeedin_userinfo = "";
      var loggedin_user_unique_id = "";
      debugger;
      this.showloader = true;
      var patientmob = this.patientmobno;
      var provider = JSON.parse(localStorage.getItem("loggedInUserInfo"));
      var api_url = rest_service.baseURL + "/Package/getPatientActivePackages";
      // var api_url =
      //  "http://localhost:49517/api/V1/Package/getPatientActivePackages";
      if (window.localStorage.getItem("accesstoken")) {
        authenticationToken = window.localStorage.getItem("accesstoken");
      }
      var tenantId = provider.tenant_id; // self.$store.state.helper.tenant_id;

      if (provider) {
        if (provider.role) {
          role_unique_id = provider.role.unique_id;
          loggedin_user_unique_id = provider.unique_id;
        }
      }
      return Axios.request({
        method: "get",
        url: api_url,
        headers: {
          x_tenant_id: tenantId,
          role_unique_id: role_unique_id,
          route_entity_name: "/Package",
          loggedin_user_unique_id: loggedin_user_unique_id,
          Authorization: authenticationToken,
          //"Accept-Encoding": "gzip"
        },
        params: {
          phone: patientmob,
        },
      })
        .then((response) => {
          debugger;
          if (response.data.result.length > 0) {
            this.showloader = false;
            //this.uploadedannfiles = response.data.result;
            var result = response.data.result;
            var result_temp = [];
            this.active_packages = result;
          } else {
            this.showloader = false;
          }
        })
        .catch(function (error) {
          this.showloader = false;
          return error;
        });
    },
    closePopUp: function (item) {
      if (item === "goBack") {
        if (this.$parent.showpackageslist) {
          this.$parent.showpackageslist = false;
        }
      }
    },
    checkencounterstatus() {
      var apiUrl =
        rest_service.baseURL +
        getencounterstatusurl +
        "?range_key=" +
        this.$parent.encounterID;
      Axios.get(apiUrl, {
        headers: {
          x_tenant_id: this.tenant_id,
          role_unique_id: this.role_unique_id,
          route_entity_name: "/formrender",
          loggedin_user_unique_id: this.loggedin_user_unique_id,
          Authorization: this.authenticationToken,
        },
      })
        .then((xy) => {
          if (xy && xy.data && xy.data.result) {
            this.isEncounterActive =
              xy.data.result.record_status === 2 ? false : true;
          }
        })
        .catch((c) => {
          console.error("Some Error Occured>>>.", c);
        });
    },
    textEllipsis(str, maxLength) {
      return Auth.truncTextEllipsis(str, maxLength);
    },
    viewFile: function (item) {
      this.getdownloadfileUrl = null;
      if (item.category == "Annotated") {
        this.foldername = "0/" + item.unique_id;
      } else {
        this.foldername =
          this.tenant_id +
          this.$store.state.helper.tenant_s3upload_Folders.UploadedImagePath +
          item.report_file_key;
      }
      this.viewItem = true;
      this.downLoadItem = false;
      if (Auth.checkAuthentication()) {
        this.getUrlFromS3Bucket(this.foldername, item.report_actual_name);
      }
    },
    getUrlFromS3Bucket(fileKey, extension) {
      var self = this;
      var suburl = "/Annotate";
      var apiUrl = rest_service.baseURL + suburl + "/getannotatedfileurl";
      //   var apiUrl = "http://localhost:49517/api/V1/Annotate/getannotatedfileurl";
      return Axios.get(apiUrl, {
        headers: {
          x_tenant_id: this.tenant_id,
          role_unique_id: this.role_unique_id,
          route_entity_name: suburl,
          loggedin_user_unique_id: this.loggedin_user_unique_id,
          Authorization: this.authenticationToken,
          report_key: fileKey,
        },
      })
        .then(function (response) {
          if (response != null && response.data != null) {
            self.getdownloadfileUrl = response.data.result;
            if (/\.(pdf)$/i.test(extension)) {
              window.open(self.getdownloadfileUrl, "_blank", "channelmode=1");
            } else if (/\.(gif|jpg|jpeg|png|webp)$/i.test(extension)) {
              $("#viewbalance").modal("show");
            } else {
              $("#viewbalance").modal("show");
            }
            //$("#viewbalance").modal("show");
            //console.log("REPORT VIEW URL>>>>>",self.getdownloadfileUrl);
            // window.open(self.getdownloadfileUrl,"_blank","channelmode=1");
          } else {
            $("#viewbalance").modal("hide");
            return null;
          }
        })
        .catch(function (error) {
          return error;
        });
    },
    formatDate(dt) {
      return moment(dt).format("DD-MM-YYYY hh:mm A");
    },
  },
  computed: {
    showClosePopUp() {
      var self = this;
      self.show_modal = self.showlist;
      if (!self.showlist) {
        this.reportListIndex = 0;
        document.body.classList.remove("modal-open");
      } else {
        document.body.classList.add("modal-open");
      }
    },
    getParentProperty() {
      this.parentproperty = this.parentObj;
    },
    getConfirmBoxResponse() {
      if (this.confrmPopUpResponse) {
        // this.confirmDelete(this.recordToDelete, this.recordType);
        this.checkservices();
      } else {
        this.confrmPopUpResponse = false;
      }
    },
  },
  watch: {
    show_modal: function (val, oldVal) {
      //this.getFileListFromParent = !val;
    },
    selectedservice(val) {
      this.markingservice = [];
      this.selectedservice.forEach((element) => {
        this.activeList.forEach((ele) => {
          if (ele.Unique_id == element.Unique_id) {
            if (!ele.Active) {
              this.markingservice.push(ele);
            }
          }
        });
      });
    },
  },
  updated() {},
};
</script>




<style scoped>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  display: table;
  transition: opacity 0.3s ease-in-out;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.view-balance .modal-dialog .modal-content.file-content {
  padding: 0;
  min-width: 600px;
  left: -25%;
}
.wallet-balance img {
  margin-right: 20px;
  margin: 0 auto;
  display: block;
  max-width: 100%;
}
.modal-container {
  width: 500px;
  margin: 0px auto;
  padding: 20px 50px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: opacity 0.5s ease-in-out;
  border-radius: 10px;
}

.modal-header h3 {
  margin-top: 0;
  color: #42b983;
}

.modal-body {
  margin: 20px 0;
}

.modal-default-button {
  float: right;
}

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
.filelisthold {
  max-height: 300px;
  overflow-y: auto;
  overflow-x: hidden;
}
.reportlist-cred {
  width: 100%;
  display: block;
  float: left;
  /* background: #f3f7fa !important; */
  padding: 8px;
}

.reportlist-cred p:first-child {
  width: 100%;
  display: block;
  padding: 0 0;
  margin: 0 0 8px 0;
}

.reportlist-cred p {
  margin-bottom: 0px;
  font-weight: 400;
  text-align: left;
}

.global-edit-ico {
  background: url(../../static/images/material_co_icon.png) -102px -242px
    no-repeat;
  width: 35px;
  height: 22px;
  display: inline-block;
  border-bottom: 0px !important;
  position: relative;
  right: 8px;
}
.modal-mask.upl-holdNEW .modal-header {
  padding: 0;
  border: 0;
}
.modal-mask.upl-holdNEW h4.modal-title {
  text-align: center;
  width: 100%;
}
.modal-mask.upl-holdNEW .modal-body {
  padding: 20px;
  margin: 0;
}
p.sub-head-uplmodal {
  font-weight: 500;
  text-align: left;
  border-bottom: 1px solid #f1f1f1;
  padding-bottom: 4px;
}
.filelisthold {
  max-height: 300px;
  overflow-y: auto;
  overflow-x: hidden;
}
.row.upl-hover {
  margin-bottom: 0;
  padding: 10px 0 10px 10px;
}
.btn.btn-downloadico,
.btn.btn-downloadico:active,
.btn.btn-downloadico:focus {
  background: url(../../static/images/dashboard-newicons.png) 1px -741px no-repeat !important;
  width: 35px;
  height: 40px;
  float: left;
  display: block;
  outline: 0;
  -webkit-box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0) !important;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0) !important;
  cursor: pointer;
  background-color: #f3f7fa !important;
}
.test-reports-right a.down-link.tkout-wrap {
  width: auto;
  white-space: inherit;
  overflow: visible;
  text-overflow: inherit;
  padding: 0 8px 2px;
  float: left;
}
.reportlist-cred .user-nameicon,
.reportlist-cred .user-pwicon {
  width: 28px;
  height: 20px;
  display: inline-block;
  margin-right: 0;
  position: relative;
  top: 4px;
}
.user-nameicon {
  background: url(../../static/images/signin-icon.png) -0px -2px no-repeat !important;
  background-size: 80px auto !important;
  -webkit-filter: grayscale(100%);
  filter: grayscale(100%);
}
.user-pwicon {
  background: url(../../static/images/signin-icon.png) -0px -44px no-repeat !important;
  background-size: 80px auto !important;
  -webkit-filter: grayscale(100%);
  filter: grayscale(100%);
}
.filename {
  float: left;
  width: calc(100% - 35px);
}
.timehold {
  font-size: 13px;
  padding: 0 8px;
  float: left;
  width: 100%;
  text-align: left;
}

.prevnxt-btnhold {
  width: 450px;
  margin: 0 auto;
  display: flex;
}
.prevnxt-btnhold .label-hold,
.prevnxt-btnhold .label-hold span {
  text-align: center;
  display: inline-block;
  width: 342px;
  word-break: break-word;
  font-weight: 500;
  font-size: 14px;
  padding: 2px 0;
}
.prevnxt-btnhold .fc-state-default.fc-corner-left,
.prevnxt-btnhold .fc-state-default.fc-corner-right {
  border-radius: 50%;
  width: 30px;
  height: 30px;
  padding: 6px;
  justify-content: center;
}
.prevnxt-btnhold .fc-state-default.fc-corner-left:focus,
.prevnxt-btnhold .fc-state-default.fc-corner-right:focus {
  outline: transparent;
}
.modal-mask.upl-holdNEW.wdth-700 .modal-container {
  width: 500px;
}

.modal-mask:before {
  display: inline-block;
  vertical-align: middle;
  content: " ";
  height: 100%;
}

.modal-wrapper {
  display: inline-block;
  text-align: left;
  vertical-align: middle;
  width: 100%;
}

.reportlist-cred {
  text-align: left;
}
.row.upl-hover:hover {
  background: #f8f9fa;
}
.fileulpd-sec {
  width: 100%;
  margin: 0 auto;
  display: block;
  border-bottom: 1px solid #f1f1f1;
  margin-bottom: 10px;
}
.fileulpd-sec p.sub-head-uplmodal {
  border-bottom: 0px solid transparent;
  margin-bottom: 0;
}
p.p-blue1.sub-head-uplmodal {
  color: #0157e0;
}
button.fc-prev-button.fc-button.fc-state-default.fc-corner-left.invest-pre-BTN {
  background: #c9cdd4;
  color: #55627b;
  border: 0px transparent;
  padding: 5px 4px;
  height: 26px;
  width: 26px;
  text-shadow: none !important;
  box-shadow: none !important;
  cursor: pointer;
}
button.fc-next-button.fc-button.fc-state-default.fc-corner-right.invest-nxt-BTN {
  background: #c9cdd4;
  color: #55627b;
  border: 0px transparent;
  padding: 5px 4px;
  height: 26px;
  width: 26px;
  text-shadow: none !important;
  box-shadow: none !important;
  cursor: pointer;
}
button.fc-prev-button.fc-button.fc-state-default.fc-corner-left.invest-pre-BTN:hover,
button.fc-next-button.fc-button.fc-state-default.fc-corner-right.invest-nxt-BTN:hover {
  background: #55627b;
  color: #ffffff;
}

.imgPreview .modal-body img {
  max-width: 100%;
  max-height: 500px;
  margin: 0 auto;
  display: block;
}
.modal-mask.upl-holdNEW .imgPreview .close {
  right: 10px;
}
.add-comment-hold.view-packages {
  position: relative;
  float: right;
  padding-right: 10px;
}
.add-comment-hold.view-packages:before {
  background: #0157e0;
  width: 1px;
  height: 24px;
  position: absolute;
  right: 0;
  content: "";
  top: 5px;
}

.packages-popup .modal-body {
  text-align: center;
  margin: 0;
}
.packages-popup .modal-body h2 {
  font-size: 20px !important;
  margin: 0 0 30px;
}
.view-packages-button {
  display: flex;
  justify-content: center;
}
.view-packages-button button {
  margin: 0 15px;
}
.packages-popup .modal-dialog .modal-content {
  padding-top: 0;
}
.packages-popup .modal-dialog .modal-header {
  min-height: inherit;
  padding-top: 10px;
}
.packages-inner-popup .modal-dialog {
  max-width: 800px;
}
.modal-mask.upl-holdNEW .close {
  right: 10px;
  top: 4px;
}
.modal-mask.upl-holdNEW .close.up-close {
  right: -38px;
  top: -13px;
}
.global-disabled input[type="checkbox"]:checked {
  accent-color: #ccc;
}
</style>
